import { css } from '@emotion/react';

export const styles = {
  footer: css`
    width: 100%;
    background-color: #0C1018;
    border: 1px solid #242A37;
    padding-top: 1em;
    padding-bottom: 2em;
    bottom: 0;
    left: 0;
  `,
  text: css`
    text-align: center;
    text-decoration: underline;
    color:white;
  `,
  row: css`
    margin-top: 1.5em;
  `
};